import { defineSetting } from '../settingsRegistry';

declare module '../settingsRegistry' {
  interface Settings {
    /**
     * Frosted glass (ui/hud-glass.css, ui/panels-ink.css): the HUD's panels and the windows blur the
     * world behind them. Off: the same panels as plain see-through fills, cheaper on weak graphics.
     * Applied as `data-blur` on the root element (main.ts).
     */
    uiBlur: boolean;
  }
}

defineSetting({
  key: 'uiBlur',
  default: true,
  order: 120,
  menu: { group: 'visual', label: 'เบลอฉากหลังใต้ HUD และหน้าต่าง' },
});
